<template>
  <div id="app">
    <demo-mode />
    <component :is="layout">
      <router-view />
    </component>
    <footer-content />
  </div>
</template>
<script>
const default_layout = "default";
export default {
  name: "App",
  components: {},
  computed: {
    layout() {
      return (this.$route.meta.layout || default_layout) + "-layout";
    },
  },
};
</script>

<style>
/* Toast and Alert Styles */
.premium-toast-container {
  z-index: 9999 !important; /* Very high z-index to appear above dialogs */
}

.premium-toast {
  font-family: 'Roboto', sans-serif;
  padding: 12px 20px !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15) !important;
  border-radius: 8px !important;
  border-left: 4px solid #6200ea !important;
  color: #333 !important;
  background-color: rgba(255, 255, 255, 0.98) !important;
}

.premium-alert-container {
  z-index: 9999 !important; /* Very high z-index to appear above dialogs */
}

.premium-alert {
  font-family: 'Roboto', sans-serif;
  padding: 20px !important;
  box-shadow: 0 6px 25px rgba(0, 0, 0, 0.18) !important;
  border-radius: 12px !important;
  background-color: rgba(255, 255, 255, 0.98) !important;
}

/* Override SweetAlert's default z-index */
.swal2-container {
  z-index: 10000 !important; /* Higher than any other element */
}

/* Success Toast Styling */
.swal2-icon.swal2-success {
  border-color: #6200ea !important;
  color: #6200ea !important;
}

/* Error Toast Styling */
.swal2-icon.swal2-error {
  border-color: #f44336 !important;
}
</style>
